import type { EmailTemplateDocument } from '../useData';

export function sanitizeLibraryDocumentName(name: string): string {
  const trimmed = name.trim().slice(0, 255);
  return trimmed || 'Document';
}

export function findLibraryDocumentByName(
  documents: EmailTemplateDocument[],
  folderId: number,
  filename: string,
): EmailTemplateDocument | undefined {
  const name = sanitizeLibraryDocumentName(filename);
  return documents.find((document) => document.folderId === folderId && document.name === name);
}

export function suggestLibraryDocumentRename(
  filename: string,
  folderDocuments: EmailTemplateDocument[],
): string {
  const sanitized = sanitizeLibraryDocumentName(filename);
  const dot = sanitized.lastIndexOf('.');
  const stem = dot > 0 ? sanitized.slice(0, dot) : sanitized;
  const ext = dot > 0 ? sanitized.slice(dot) : '';
  const names = new Set(folderDocuments.map((document) => document.name));
  let n = 2;
  while (names.has(`${stem} (${n})${ext}`)) n += 1;
  return `${stem} (${n})${ext}`;
}
